import type { CountryCode } from "@config/site/types";

export function formatPhoneNumberByCountry(phoneNumber: string, country: CountryCode): string {
    if (country === "JP") {
        const jpRegex = /^(\d{2,3})(\d{4})(\d{4})$/;
        const jpReplacement = "$1-$2-$3";
        return phoneNumber?.replace(jpRegex, jpReplacement);
    }

    return phoneNumber;
}

export function cleanPhoneNumber(phoneNumber: string, country: CountryCode): string {
    if (country.includes("JP") && phoneNumber) {
        return phoneNumber.replace(/-/g, "");
    }

    return phoneNumber;
}
